<div class="container">
  <form [formGroup]="loginForm" class="loginFormClass" autocomplete="off">
    <div class="lgFrmCard">
      <div class="form-group">
        <label for="email" class="form-label">Email</label>
        <div class="input-field">
          <input
            formControlName="email"
            id="email"
            name="email"
            class="form-control"
            type="text"
            placeholder="User@example.com"
            autocomplete="off"
          />
        </div>
        @if (
          loginSubmitted() &&
          loginForm.controls["email"].invalid &&
          loginForm.controls["email"].dirty &&
          loginForm.hasError("required", "email")
        ) {
          <span class="text-danger"> Email is required. </span>
        }
        @if (
          loginSubmitted() &&
          loginForm.controls["email"].value != "" &&
          loginForm.controls["email"].hasError("pattern")
        ) {
          <span class="text-danger"> Please enter valid email. </span>
        }
      </div>
      @if (showBtn()) {
        <div class="form-group">
          <label class="from-label" for="pwd">Password</label>
          <div class="input-field">
            <input
              formControlName="pwd"
              id="pwd"
              name="pwd"
              class="form-control"
              autocomplete="off"
              [type]="type"
              placeholder="Password"
              (input)="removePasswordSpaces($event)"
            />
            <span style="position: relative">
              <span
                class="fa {{ eyeIcon }} passwordEye"
                (click)="hideShowPassword()"
                (keydown.enter)="hideShowPassword()"
                (keydown.space)="hideShowPassword()"
              ></span>
            </span>
          </div>
          @if (loginSubmitted() && loginForm.hasError("required", "pwd")) {
            <span class="text-danger"> Please enter password. </span>
          }
          @if (
            loginSubmitted() &&
            loginForm.controls["pwd"].invalid &&
            loginForm.controls["pwd"].dirty &&
            loginForm.hasError("pattern", "pwd")
          ) {
            <span class="text-danger"> Enter valid password. </span>
          }
        </div>

        <!-- OTP field — only for PASSWORD_OTP flow -->
        @if (showOtpField()) {
          <div class="form-group">
            <label class="form-label" for="otpInput">OTP</label>
            <div class="input-field">
              <input
                id="otpInput"
                class="form-control"
                type="text"
                inputmode="numeric"
                maxlength="6"
                placeholder="Enter OTP sent to your email/mobile"
                [(ngModel)]="otpInputValue"
                [ngModelOptions]="{ standalone: true }"
                (input)="onOtpInput($event)"
                autocomplete="off"
              />
            </div>
            @if (loginSubmitted() && showOtpField() && !otpInputValue?.trim()) {
              <span class="text-danger"> Please enter OTP. </span>
            }
          </div>
        }
      }

      <!-- CAPTCHA — shown after email verified, guards both OTP and password flows -->
      @if (captchaReady()) {
        <div class="form-group captcha-group">
          <label for="" class="form-label">Verify you are human</label>

          <div class="captcha-row">
            <div class="captcha-canvas-wrap">
              <canvas id="captchaCanvas" width="180" height="44"></canvas>
            </div>
            <button
              type="button"
              class="captcha-refresh-btn"
              (click)="generateCaptcha()"
              (keydown.enter)="generateCaptcha()"
              title="Refresh"
              aria-label="Refresh CAPTCHA"
            >
              <i class="fa fa-refresh"></i>
            </button>
          </div>

          <div class="input-field">
            <input
              class="form-control"
              type="text"
              maxlength="6"
              placeholder="Case-sensitive, enter exactly as shown"
              [(ngModel)]="captchaInput"
              [ngModelOptions]="{ standalone: true }"
              (input)="verifyCaptcha()"
              autocomplete="off"
            />
          </div>

          @if (captchaSubmitted && !captchaVerified) {
            <span class="text-danger">
              Incorrect characters. Please try again.
            </span>
          }
        </div>
      }

      <!-- Continue button before email verified -->
      @if (!showBtn()) {
        <button
          class="btn btn-primary signInBtn"
          type="submit"
          [disabled]="spinner()"
          (click)="validateUserEmail()"
          (keydown.enter)="validateUserEmail()"
        >
          @if (spinner()) {
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw fa-spinner-login">
              <span class="sr-only">Loading...</span>
            </i>
          }
          Continue
        </button>
      }

      <!-- Sign In button  after email verified -->
      @if (showBtn()) {
        <button
          class="btn btn-primary signInBtn"
          type="submit"
          [disabled]="spinner()"
          (click)="signIn()"
          (keydown.enter)="signIn()"
        >
          @if (spinner()) {
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw fa-spinner-login">
              <span class="sr-only">Loading...</span>
            </i>
          }
          Sign In
        </button>
      }
      <p class="fgtpwd">
        <a (click)="forgotpass()" (keydown.enter)="forgotpass()"
          >Forgot Password?</a
        >
      </p>
      <p class="regtrNew">
        Don't have an account?
        <a (click)="signUp()" (keydown.enter)="signUp()"> Sign Up</a>
      </p>
    </div>
  </form>
</div>
